(function () {
  const config = window.BRICKFEVER_LEGO_BG_CONFIG;
  if (!config || !config.enabled) return;

  const root = document.getElementById('site-lego-background');
  if (!root) return;

  function setRootBackground() {
    const base = config.colorsBase || {};
    root.style.background = [
      `radial-gradient(circle at 50% 40%, ${base.pageTop || 'rgba(255,255,255,0.55)'}, rgba(255,255,255,0) 32%)`,
      `linear-gradient(180deg, ${base.pageBackgroundStart || '#efefef'}, ${base.pageBackgroundMid || '#e2e2e2'} 58%, ${base.pageBackgroundEnd || '#d9d9d9'} 100%)`
    ].join(',');
  }

  function createLogoTexture(THREE, color) {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 128;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = color || '#d6d6d6';
    ctx.font = '700 96px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('LEGO', canvas.width / 2, canvas.height / 2 + 2);

    const texture = new THREE.CanvasTexture(canvas);
    texture.needsUpdate = true;
    texture.generateMipmaps = true;
    texture.colorSpace = THREE.SRGBColorSpace;
    return texture;
  }

  function loadThree() {
    if (window.THREE) return Promise.resolve(window.THREE);

    return new Promise(function (resolve, reject) {
      const existing = document.querySelector('script[data-three-cdn="true"]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.THREE); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://unpkg.com/three@0.160.0/build/three.min.js';
      script.async = true;
      script.dataset.threeCdn = 'true';
      script.onload = function () { resolve(window.THREE); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  loadThree().then(function (THREE) {
    setRootBackground();
    document.body.classList.add('lego-background-enabled');

    const cameraTarget = new THREE.Vector3(
      config.camera.target.x,
      config.camera.target.y,
      config.camera.target.z
    );

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      config.camera.fov,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    camera.position.set(config.camera.position.x, config.camera.position.y, config.camera.position.z);
    camera.lookAt(cameraTarget);

    const renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      powerPreference: 'high-performance'
    });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, config.maxRenderPixelRatio));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.NoToneMapping;
    renderer.shadowMap.enabled = config.enableShadows;
    renderer.shadowMap.type = THREE.BasicShadowMap;
    root.appendChild(renderer.domElement);

    scene.add(new THREE.AmbientLight(0xffffff, 2.15));

    const keyLight = new THREE.DirectionalLight(0xffffff, 1.15);
    keyLight.position.set(-8, 8, 10);
    scene.add(keyLight);

    const fillLight = new THREE.DirectionalLight(0xffffff, 0.95);
    fillLight.position.set(8, 3, 7);
    scene.add(fillLight);

    const topRightLight = new THREE.DirectionalLight(0xffffff, 0.7);
    topRightLight.position.set(14, 10, 12);
    scene.add(topRightLight);

    const plateDepth = 0.24;
    const spacingX = 0.285 * config.studSpacingScale;
    const spacingY = 0.285 * config.studSpacingScale;
    const radialSegments = Math.max(18, config.studRadialSegments * 2);
    const projectedPoint = new THREE.Vector3();

    const studParts = config.studParts || {};
    const bottomPart = studParts.bottom || {};
    const middlePart = studParts.middle || {};
    const topPart = studParts.top || {};

    const bottomHeight = bottomPart.height ?? 0.05;
    const middleHeight = middlePart.height ?? 0.08;
    const topHeight = topPart.height ?? 0.105;

    const staticBottomStartRadius = 0.0 * config.studScale;
    const staticBottomEndRadius = 0.0 * config.studScale;
    const staticMiddleStartRadius = 0.0 * config.studScale;
    const staticMiddleEndRadius = 0.0 * config.studScale;
    const staticTopStartRadius = 0.0 * config.studScale;
    const staticTopEndRadius = 0.0 * config.studScale;

    const whiteBottomStartRadius = (bottomPart.startRadius ?? 0.112) * config.studScale;
    const whiteBottomEndRadius = (bottomPart.endRadius ?? 0.122) * config.studScale;
    const whiteMiddleStartRadius = (middlePart.startRadius ?? 0.168) * config.studScale;
    const whiteMiddleEndRadius = (middlePart.endRadius ?? 0.168) * config.studScale;
    const whiteTopStartRadius = (topPart.startRadius ?? 0.114) * config.studScale;
    const whiteTopEndRadius = (topPart.endRadius ?? 0.114) * config.studScale;

    const staticBottomGeo = new THREE.CylinderGeometry(
      staticBottomStartRadius,
      staticBottomEndRadius,
      bottomHeight,
      radialSegments
    );
    const staticMiddleGeo = new THREE.CylinderGeometry(
      staticMiddleStartRadius,
      staticMiddleEndRadius,
      middleHeight,
      radialSegments
    );
    const staticTopGeo = new THREE.CylinderGeometry(
      staticTopStartRadius,
      staticTopEndRadius,
      topHeight,
      radialSegments
    );

    const whiteBottomGeo = new THREE.CylinderGeometry(
      whiteBottomStartRadius,
      whiteBottomEndRadius,
      bottomHeight,
      radialSegments
    );
    const whiteMiddleGeo = new THREE.CylinderGeometry(
      whiteMiddleStartRadius,
      whiteMiddleEndRadius,
      middleHeight,
      radialSegments
    );
    const whiteTopGeo = new THREE.CylinderGeometry(
      whiteTopStartRadius,
      whiteTopEndRadius,
      topHeight,
      radialSegments
    );
    const logoGeo = new THREE.PlaneGeometry(0.16 * config.studScale, 0.07 * config.studScale);

    const tempObj = new THREE.Object3D();
    const scratchColor = new THREE.Color();
    const raycaster = new THREE.Raycaster();
    const pointer = new THREE.Vector2(999, 999);
    const samplePointer = new THREE.Vector2();
    const sampledStuds = new Set();
    const activeStuds = new Map();
    const clock = new THREE.Clock();

    const whiteBottomDefaultColor = new THREE.Color(config.colorsBase.whiteStudBase).multiplyScalar(0.88);
    const whiteMiddleDefaultColor = new THREE.Color(config.colorsBase.whiteStudBase).multiplyScalar(0.97);
    const whiteTopDefaultColor = new THREE.Color(config.colorsBase.whiteStudTop);
    const defaultLogoColor = config.colorsBase.logoText || '#d6d6d6';

    const logoMaterialCache = new Map();

    let hoveredStudIndex = -1;
    let boardGroup = null;
    let boardState = null;
    let viewportBounds = {
      left: 0,
      top: 0,
      width: window.innerWidth,
      height: window.innerHeight
    };

    function randomConfiguredColor() {
      const palette = config.colors && config.colors.length ? config.colors : ['#ff6b6b'];
      return new THREE.Color(palette[Math.floor(Math.random() * palette.length)]);
    }

    function getHoverLogoColor(color) {
      const darken = config.hoverColors && typeof config.hoverColors.textDarken === 'number'
        ? config.hoverColors.textDarken
        : 0.45;

      return color.clone().multiplyScalar(Math.max(0, Math.min(1, darken)));
    }

    function getLogoMaterial(hexColor) {
      const key = hexColor.toLowerCase();

      if (!logoMaterialCache.has(key)) {
        const texture = createLogoTexture(THREE, key);
        const material = new THREE.MeshBasicMaterial({
          map: texture,
          transparent: true,
          depthWrite: false,
          opacity: 0.92
        });

        logoMaterialCache.set(key, material);
      }

      return logoMaterialCache.get(key);
    }

    function getFooterElement() {
      return document.querySelector('.shopify-section-group-footer-group')
        || document.querySelector('footer.footer')
        || document.querySelector('.section-footer');
    }

    function updateViewportMask() {
      const footer = getFooterElement();
      let bottomInset = 0;

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight) {
          bottomInset = Math.max(0, window.innerHeight - Math.max(0, footerRect.top));
        }
      }

      root.style.top = '0';
      root.style.bottom = Math.round(bottomInset) + 'px';
      root.style.left = '0';
      root.style.right = '0';

      const rect = root.getBoundingClientRect();
      viewportBounds = {
        left: rect.left,
        top: rect.top,
        width: Math.max(1, rect.width),
        height: Math.max(1, rect.height)
      };
    }

    function syncRendererPixelRatio() {
      const nextRatio = Math.min(window.devicePixelRatio || 1, config.maxRenderPixelRatio);
      if (renderer.getPixelRatio() !== nextRatio) {
        renderer.setPixelRatio(nextRatio);
        return true;
      }
      return false;
    }

    function applyRendererBounds() {
      updateViewportMask();
      syncRendererPixelRatio();
      camera.aspect = viewportBounds.width / viewportBounds.height;
      camera.updateProjectionMatrix();
      renderer.setSize(viewportBounds.width, viewportBounds.height, true);
      renderer.domElement.style.width = '';
      renderer.domElement.style.height = '';
      renderer.domElement.style.maxWidth = 'none';
      renderer.domElement.style.maxHeight = 'none';
    }

    function getResponsivePlateSize() {
      const aspect = viewportBounds.width / viewportBounds.height;
      const distance = camera.position.distanceTo(cameraTarget);
      const visibleHeight = 2 * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2)) * distance;
      const visibleWidth = visibleHeight * aspect;

      return {
        plateWidth: Math.max(config.board.minPlateWidth, visibleWidth * config.board.widthOverscan),
        plateHeight: Math.max(config.board.minPlateHeight, visibleHeight * config.board.heightOverscan)
      };
    }

    function isInCameraView(board, x, y, z) {
      projectedPoint.set(x, y, z);
      board.localToWorld(projectedPoint);
      projectedPoint.project(camera);

      return (
        projectedPoint.z >= -1 &&
        projectedPoint.z <= 1 &&
        projectedPoint.x >= -1.15 &&
        projectedPoint.x <= 1.15 &&
        projectedPoint.y >= -1.15 &&
        projectedPoint.y <= 1.15
      );
    }

    function setLogoMaterial(index, color) {
      if (!boardState || !boardState.logoMeshes[index]) return;
      const hex = '#' + color.getHexString();
      boardState.logoMeshes[index].material = getLogoMaterial(hex);
    }

    function setStudMatrices(index, x, y, lift) {
      tempObj.rotation.x = Math.PI / 2;

      tempObj.position.set(x, y, boardState.whiteRestZ + bottomHeight / 2 + lift);
      tempObj.updateMatrix();
      boardState.whiteBottomMesh.setMatrixAt(index, tempObj.matrix);

      tempObj.position.set(x, y, boardState.whiteRestZ + bottomHeight + middleHeight / 2 + lift);
      tempObj.updateMatrix();
      boardState.whiteMiddleMesh.setMatrixAt(index, tempObj.matrix);

      tempObj.position.set(x, y, boardState.whiteRestZ + bottomHeight + middleHeight + topHeight / 2 + lift);
      tempObj.updateMatrix();
      boardState.whiteTopMesh.setMatrixAt(index, tempObj.matrix);

      if (boardState.logoMeshes[index]) {
        boardState.logoMeshes[index].position.set(x, y, boardState.whiteLogoZ + lift);
      }
    }

    function setStudColors(index, topColor, mix) {
      scratchColor.copy(whiteBottomDefaultColor).lerp(topColor, mix).multiplyScalar(0.84);
      boardState.whiteBottomMesh.setColorAt(index, scratchColor);

      scratchColor.copy(whiteMiddleDefaultColor).lerp(topColor, mix).multiplyScalar(0.92);
      boardState.whiteMiddleMesh.setColorAt(index, scratchColor);

      scratchColor.copy(whiteTopDefaultColor).lerp(topColor, mix);
      boardState.whiteTopMesh.setColorAt(index, scratchColor);
    }

    function resetStud(index) {
      const p = boardState.positions[index];
      if (!p) return;
      setStudMatrices(index, p.x, p.y, 0);
      boardState.whiteBottomMesh.setColorAt(index, whiteBottomDefaultColor);
      boardState.whiteMiddleMesh.setColorAt(index, whiteMiddleDefaultColor);
      boardState.whiteTopMesh.setColorAt(index, whiteTopDefaultColor);
      setLogoMaterial(index, new THREE.Color(defaultLogoColor));
    }

    function disposeBoard() {
      if (!boardState) return;

      scene.remove(boardGroup);

      boardState.plate.geometry.dispose();
      boardState.plateMaterial.dispose();
      boardState.staticBottomMat.dispose();
      boardState.staticMiddleMat.dispose();
      boardState.staticTopMat.dispose();
      boardState.whiteBottomMat.dispose();
      boardState.whiteMiddleMat.dispose();
      boardState.whiteTopMat.dispose();

      boardState.logoMeshes.forEach(function (mesh) {
        mesh.geometry.dispose();
      });

      boardState = null;
      boardGroup = null;
    }

    function buildBoard() {
      if (boardState) disposeBoard();
      activeStuds.clear();
      hoveredStudIndex = -1;

      const size = getResponsivePlateSize();

      boardGroup = new THREE.Group();
      boardGroup.rotation.x = THREE.MathUtils.degToRad(config.board.rotationXDeg);
      boardGroup.rotation.y = THREE.MathUtils.degToRad(config.board.rotationYDeg);
      boardGroup.position.set(config.board.position.x, config.board.position.y, config.board.position.z);
      scene.add(boardGroup);
      boardGroup.updateMatrixWorld(true);

      const plateMaterial = new THREE.MeshStandardMaterial({
        color: new THREE.Color(config.colorsBase.plate),
        roughness: 0.6,
        metalness: 0
      });

      const staticBottomMat = new THREE.MeshStandardMaterial({
        color: new THREE.Color(config.colorsBase.yellowStudBase).multiplyScalar(0.86),
        roughness: 0.74,
        metalness: 0
      });
      const staticMiddleMat = new THREE.MeshStandardMaterial({
        color: new THREE.Color(config.colorsBase.yellowStudBase),
        roughness: 0.68,
        metalness: 0
      });
      const staticTopMat = new THREE.MeshStandardMaterial({
        color: new THREE.Color(config.colorsBase.yellowStudTop),
        roughness: 0.58,
        metalness: 0
      });

      const whiteBottomMat = new THREE.MeshStandardMaterial({
        color: whiteBottomDefaultColor.clone(),
        roughness: 0.6,
        metalness: 0
      });
      const whiteMiddleMat = new THREE.MeshStandardMaterial({
        color: whiteMiddleDefaultColor.clone(),
        roughness: 0.52,
        metalness: 0
      });
      const whiteTopMat = new THREE.MeshStandardMaterial({
        color: whiteTopDefaultColor.clone(),
        roughness: 0.42,
        metalness: 0
      });

      const plate = new THREE.Mesh(
        new THREE.BoxGeometry(size.plateWidth, size.plateHeight, plateDepth),
        plateMaterial
      );
      plate.castShadow = config.enableShadows;
      plate.receiveShadow = config.enableShadows;
      boardGroup.add(plate);

      const rows = Math.ceil((size.plateHeight + spacingY) / spacingY);
      const halfExtentX = size.plateWidth / 2 + spacingX;
      const seamOffset = spacingX * 0.5;
      const maxPair = Math.ceil((halfExtentX - seamOffset) / spacingX);

      const positions = [];
      const startY = size.plateHeight / 2 + spacingY * 0.5;

      for (let row = 0; row < rows; row++) {
        const y = startY - row * spacingY;

        for (let pair = 0; pair < maxPair; pair++) {
          const xRight = seamOffset + pair * spacingX;

          if (isInCameraView(boardGroup, xRight, y, plateDepth / 2)) {
            positions.push({ x: xRight, y, hoverColor: randomConfiguredColor() });
          }
          if (isInCameraView(boardGroup, -xRight, y, plateDepth / 2)) {
            positions.push({ x: -xRight, y, hoverColor: randomConfiguredColor() });
          }
        }
      }

      if (positions.length < 12) {
        positions.length = 0;
        for (let row = 0; row < rows; row++) {
          const y = startY - row * spacingY;
          for (let pair = 0; pair < maxPair; pair++) {
            const xRight = seamOffset + pair * spacingX;
            positions.push({ x: xRight, y, hoverColor: randomConfiguredColor() });
            positions.push({ x: -xRight, y, hoverColor: randomConfiguredColor() });
          }
        }
      }

      const totalCount = positions.length;

      const staticBottomMesh = new THREE.InstancedMesh(staticBottomGeo, staticBottomMat, totalCount);
      const staticMiddleMesh = new THREE.InstancedMesh(staticMiddleGeo, staticMiddleMat, totalCount);
      const staticTopMesh = new THREE.InstancedMesh(staticTopGeo, staticTopMat, totalCount);
      const whiteBottomMesh = new THREE.InstancedMesh(whiteBottomGeo, whiteBottomMat, totalCount);
      const whiteMiddleMesh = new THREE.InstancedMesh(whiteMiddleGeo, whiteMiddleMat, totalCount);
      const whiteTopMesh = new THREE.InstancedMesh(whiteTopGeo, whiteTopMat, totalCount);

      [
        staticBottomMesh,
        staticMiddleMesh,
        staticTopMesh,
        whiteBottomMesh,
        whiteMiddleMesh,
        whiteTopMesh
      ].forEach(function (mesh) {
        mesh.castShadow = config.enableShadows;
        mesh.receiveShadow = config.enableShadows;
        boardGroup.add(mesh);
      });

      const restZ = plateDepth / 2;
      const whiteRestZ = restZ + 0.036;
      const whiteLogoZ = whiteRestZ + bottomHeight + middleHeight + topHeight + 0.003;
      const logoMeshes = [];

      for (let i = 0; i < positions.length; i++) {
        const x = positions[i].x;
        const y = positions[i].y;

        tempObj.rotation.x = Math.PI / 2;

        tempObj.position.set(x, y, restZ + bottomHeight / 2);
        tempObj.updateMatrix();
        staticBottomMesh.setMatrixAt(i, tempObj.matrix);

        tempObj.position.set(x, y, restZ + bottomHeight + middleHeight / 2);
        tempObj.updateMatrix();
        staticMiddleMesh.setMatrixAt(i, tempObj.matrix);

        tempObj.position.set(x, y, restZ + bottomHeight + middleHeight + topHeight / 2);
        tempObj.updateMatrix();
        staticTopMesh.setMatrixAt(i, tempObj.matrix);

        tempObj.position.set(x, y, whiteRestZ + bottomHeight / 2);
        tempObj.updateMatrix();
        whiteBottomMesh.setMatrixAt(i, tempObj.matrix);

        tempObj.position.set(x, y, whiteRestZ + bottomHeight + middleHeight / 2);
        tempObj.updateMatrix();
        whiteMiddleMesh.setMatrixAt(i, tempObj.matrix);

        tempObj.position.set(x, y, whiteRestZ + bottomHeight + middleHeight + topHeight / 2);
        tempObj.updateMatrix();
        whiteTopMesh.setMatrixAt(i, tempObj.matrix);

        whiteBottomMesh.setColorAt(i, whiteBottomDefaultColor);
        whiteMiddleMesh.setColorAt(i, whiteMiddleDefaultColor);
        whiteTopMesh.setColorAt(i, whiteTopDefaultColor);

        const logoMesh = new THREE.Mesh(logoGeo.clone(), getLogoMaterial(defaultLogoColor));
        logoMesh.position.set(x, y, whiteLogoZ);
        logoMesh.renderOrder = 1;
        logoMesh.castShadow = false;
        logoMesh.receiveShadow = false;
        boardGroup.add(logoMesh);
        logoMeshes.push(logoMesh);
      }

      staticBottomMesh.instanceMatrix.needsUpdate = true;
      staticMiddleMesh.instanceMatrix.needsUpdate = true;
      staticTopMesh.instanceMatrix.needsUpdate = true;
      whiteBottomMesh.instanceMatrix.needsUpdate = true;
      whiteMiddleMesh.instanceMatrix.needsUpdate = true;
      whiteTopMesh.instanceMatrix.needsUpdate = true;
      whiteBottomMesh.instanceColor.needsUpdate = true;
      whiteMiddleMesh.instanceColor.needsUpdate = true;
      whiteTopMesh.instanceColor.needsUpdate = true;

      boardState = {
        plate,
        plateMaterial,
        staticBottomMat,
        staticMiddleMat,
        staticTopMat,
        whiteBottomMat,
        whiteMiddleMat,
        whiteTopMat,
        positions,
        whiteRestZ,
        whiteLogoZ,
        whiteBottomMesh,
        whiteMiddleMesh,
        whiteTopMesh,
        logoMeshes
      };
    }

    function activateIndex(index) {
      if (!boardState || !boardState.positions[index]) return;
      const existing = activeStuds.get(index);

      activeStuds.set(index, {
        until: performance.now() + config.hoverHoldMs,
        mix: existing ? existing.mix : 0,
        color: existing ? existing.color : boardState.positions[index].hoverColor
      });
    }

    function getHitIndex(sample) {
      if (!boardState || !boardState.whiteTopMesh) return -1;
      raycaster.setFromCamera(sample, camera);
      const hits = raycaster.intersectObject(boardState.whiteTopMesh, false);
      return hits.length > 0 && hits[0].instanceId !== undefined ? hits[0].instanceId : -1;
    }

    function activateAlongPointerPath(from, to) {
      const distance = from.distanceTo(to);
      const steps = Math.min(
        config.pointerSampleMaxSteps,
        Math.max(1, Math.ceil(distance / config.pointerSampleNdcStep))
      );

      sampledStuds.clear();

      for (let s = 0; s <= steps; s++) {
        const t = s / steps;
        samplePointer.set(
          THREE.MathUtils.lerp(from.x, to.x, t),
          THREE.MathUtils.lerp(from.y, to.y, t)
        );

        const hitIndex = getHitIndex(samplePointer);
        if (hitIndex !== -1 && !sampledStuds.has(hitIndex)) {
          sampledStuds.add(hitIndex);
          activateIndex(hitIndex);
        }
      }
    }

    function updatePointer(clientX, clientY) {
      const canvasRect = renderer.domElement.getBoundingClientRect();

      if (
        clientX < canvasRect.left ||
        clientX > canvasRect.right ||
        clientY < canvasRect.top ||
        clientY > canvasRect.bottom
      ) {
        hoveredStudIndex = -1;
        return;
      }

      samplePointer.copy(pointer);

      pointer.x = ((clientX - canvasRect.left) / canvasRect.width) * 2 - 1;
      pointer.y = -(((clientY - canvasRect.top) / canvasRect.height) * 2 - 1);

      if (samplePointer.x === 999 || samplePointer.y === 999) {
        samplePointer.copy(pointer);
      }

      activateAlongPointerPath(samplePointer, pointer);
      hoveredStudIndex = getHitIndex(pointer);
    }

    function clearPointer() {
      pointer.x = 999;
      pointer.y = 999;
      samplePointer.x = 999;
      samplePointer.y = 999;
      hoveredStudIndex = -1;
    }

    function updateAnimatedStuds(now, t) {
      if (hoveredStudIndex !== -1) {
        activateIndex(hoveredStudIndex);
      }

      if (activeStuds.size === 0 || !boardState) return false;

      for (const [index, state] of activeStuds) {
        const active = state.until > now;
        const target = active ? 1 : 0;
        state.mix = THREE.MathUtils.lerp(state.mix, target, 0.18);

        if (!active && state.mix < 0.002) {
          resetStud(index);
          activeStuds.delete(index);
          continue;
        }

        const p = boardState.positions[index];
        const bob = active ? Math.sin(t * 8 + index * 0.25) * 0.002 : 0;
        const lift = state.mix * config.liftDistance + bob;

        setStudMatrices(index, p.x, p.y, lift);
        setStudColors(index, state.color, state.mix);

        if (state.mix > 0.001) {
          setLogoMaterial(index, getHoverLogoColor(state.color));
        }
      }

      boardState.whiteBottomMesh.instanceMatrix.needsUpdate = true;
      boardState.whiteMiddleMesh.instanceMatrix.needsUpdate = true;
      boardState.whiteTopMesh.instanceMatrix.needsUpdate = true;
      boardState.whiteBottomMesh.instanceColor.needsUpdate = true;
      boardState.whiteMiddleMesh.instanceColor.needsUpdate = true;
      boardState.whiteTopMesh.instanceColor.needsUpdate = true;

      return true;
    }

    function renderNow() {
      applyRendererBounds();
      buildBoard();
      renderer.render(scene, camera);
    }

    function animate() {
      requestAnimationFrame(animate);
      updateViewportMask();

      const pixelRatioChanged = syncRendererPixelRatio();
      if (pixelRatioChanged) {
        renderer.setSize(viewportBounds.width, viewportBounds.height, true);
      }

      const didUpdate = updateAnimatedStuds(performance.now(), clock.getElapsedTime());
      if (didUpdate || hoveredStudIndex !== -1 || pixelRatioChanged) {
        renderer.render(scene, camera);
      }
    }

    function handleResize() {
      renderNow();
    }

    window.addEventListener('pointermove', function (event) {
      updatePointer(event.clientX, event.clientY);
    }, { passive: true });

    window.addEventListener('pointerleave', clearPointer);
    window.addEventListener('blur', clearPointer);
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', updateViewportMask, { passive: true });

    renderNow();
    animate();
  }).catch(function (error) {
    console.error('Failed to initialize LEGO background', error);
  });
})();
